import { BuildFlavour } from './BuildFlavour'
import Logo from '../../assets/logo-pdl.svg'
import LogoSmall from '../../assets/logo-pdl-short.svg'
import { CtasPdl } from '../text/CtasPdl'
import { CopyGeneric } from '../text/Copy'
import { CopyPdl } from '../text/CopyPdl'

export const PdlFlavour: BuildFlavour = {
  builderTitle: 'PDL Iconic Builder',
  logo: Logo,
  logoHeight: '33px',
  logoWidth: '108px',
  squareLogoSize: '30px',
  logoSmall: LogoSmall,
  brandName: 'PDL',
  productDataApiEndpoint: null,
  ctas: CtasPdl,
  mailingListAddress: 'https://www.pdl.co.nz/sign-up',
  tradeMailingListAddress: 'https://www.pdl.co.nz/trade-sign-up',
  copy: { ...CopyGeneric, ...CopyPdl },
  ledModuleItemNo: 'PDL300ALED',
  currencyCode: 'NZD',
  countryCode: 'nz',
}